import mutations from './mutations';
import getters from './getters';

export const OPTIONS_STORE_RELEASES = {
  MUTATIONS: {
    UPDATE_RELEASES_STATE: 'releases/updateReleasesState'
  },
  GETTERS: {
    SHOW_RELEASES_ICON: 'releases/showReleasesIcon',
    HAS_RECENT_RELEASE: 'releases/hasRecentRelease'
  }
};

export default {
  state: {
    showReleasesIcon: false,
    hasRecentRelease: false
  },
  getters,
  mutations,
  namespaced: true
};
